import { createRoleGuard } from './role-guard';

export const isAdministratorGuard = createRoleGuard(user =>
  user.isAdministrator()
);
